'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _availabilityLink = require('@bibliocommons/availability-link');

var _availabilityLink2 = _interopRequireDefault(_availabilityLink);

var _availabilityStatus = require('@bibliocommons/availability-status');

var _availabilityStatus2 = _interopRequireDefault(_availabilityStatus);

var _holdCounts = require('@bibliocommons/hold-counts');

var _holdCounts2 = _interopRequireDefault(_holdCounts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  availabilityDetailActions: _react.PropTypes.object.isRequired,
  availabilityStatus: _react.PropTypes.object.isRequired,
  bib: _react.PropTypes.object.isRequired,
  holdable: _react.PropTypes.bool,
  showAvailabilityLink: _react.PropTypes.bool,
  showHoldCount: _react.PropTypes.bool,
  showAvailabilityStatus: _react.PropTypes.bool
};

var PhysicalBlock = function PhysicalBlock(_ref) {
  var availabilityDetailActions = _ref.availabilityDetailActions,
      availabilityStatus = _ref.availabilityStatus,
      bib = _ref.bib,
      holdable = _ref.holdable,
      showAvailabilityLink = _ref.showAvailabilityLink,
      showHoldCount = _ref.showHoldCount,
      showAvailabilityStatus = _ref.showAvailabilityStatus;
  return _react2.default.createElement(
    'div',
    { className: 'cp-physical-availability-block' },
    showAvailabilityStatus && _react2.default.createElement(_availabilityStatus2.default, {
      availabilityLocationType: availabilityStatus.get('availabilityLocationType'),
      rollUpStatus: availabilityStatus.get('status'),
      status: availabilityStatus.get('localisedStatus') }),
    '\xA0',
    showAvailabilityLink ? _react2.default.createElement(_availabilityLink2.default, {
      metadataId: bib.get('id'),
      availabilityDetailActions: availabilityDetailActions,
      title: bib.get('title'),
      format: bib.get('format'),
      status: showAvailabilityStatus && availabilityStatus.get('localisedStatus') || null,
      availabilityLocationType: availabilityStatus.get('availabilityLocationType') }) : null,
    _react2.default.createElement('br', null),
    holdable && showHoldCount ? _react2.default.createElement(_holdCounts2.default, {
      heldCopies: availabilityStatus.get('heldCopies'),
      availableCopies: availabilityStatus.get('availableCopies'),
      totalCopies: availabilityStatus.get('totalCopies') }) : null
  );
};

PhysicalBlock.propTypes = propTypes;
PhysicalBlock.defaultProps = {
  showAvailabilityLink: true,
  showAvailabilityStatus: true
};

exports.default = PhysicalBlock;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/availability-physical-block/lib/components/PhysicalBlock.component.js
// module id = 1006
// module chunks = 1